import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { gsap } from 'gsap';
import logoImg from '../asserts/logo.png';
import bgImg from '../asserts/hero.jpg';
import './login.css';
import Btn4 from '../components/common/btn4';
import Btn2 from '../components/common/btn2';
import Loader from '../components/layout/preloader';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const logoRef = useRef(null);
  const overlayTextRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const formRef = useRef(null);
  const btnGroupRef = useRef(null);
  const footerRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ defaults: { ease: 'power3.out' }, delay: 4 });
    gsap.set([leftRef.current, rightRef.current], { opacity: 0 });
    gsap.set(logoRef.current, { opacity: 0, y: -20 });
    gsap.set(overlayTextRef.current, { opacity: 0, y: 40 });
    gsap.set(titleRef.current, { opacity: 0, y: 30 });
    gsap.set(subtitleRef.current, { opacity: 0, y: 20 });
    gsap.set(formRef.current, { opacity: 0, y: 25 });
    gsap.set(btnGroupRef.current, { opacity: 0, y: 20 });
    gsap.set(footerRef.current, { opacity: 0 });
    tl.to(leftRef.current, { opacity: 1, duration: 1 })
      .to(rightRef.current, { opacity: 1, duration: 0.8 }, '-=0.6')
      .to(logoRef.current, { opacity: 1, y: 0, duration: 0.6 }, '-=0.4')
      .to(overlayTextRef.current, { opacity: 1, y: 0, duration: 0.7 }, '-=0.3')
      .to(titleRef.current, { opacity: 1, y: 0, duration: 0.6 }, '-=0.5')
      .to(subtitleRef.current, { opacity: 1, y: 0, duration: 0.5 }, '-=0.3')
      .to(formRef.current, { opacity: 1, y: 0, duration: 0.6 }, '-=0.3')
      .to(btnGroupRef.current, { opacity: 1, y: 0, duration: 0.5 }, '-=0.2')
      .to(footerRef.current, { opacity: 1, duration: 0.4 }, '-=0.1');
  }, []);

  const handleLinkClick = (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError('All fields are required.');
      return;
    }
    if (email === 'raia@gmail.com' && password === '123') {
      setError('');
      navigate('/home');
    } else {
      setError('Incorrect email or password. Please try again.');
    }
  };

  return (
    <>
      <Loader />
      <div className="login-wrapper">

        <div className="login-left" ref={leftRef}>
          <img src={bgImg} alt="background" className="login-bg-img" />
          <div className="login-left-overlay" />
          <div className="login-logo-wrap" ref={logoRef}>
            <img src={logoImg} alt="The Design Show Logo" className="login-logo" />
          </div>
          <div className="login-overlay-text" ref={overlayTextRef}>
            <h2 className="bg-title1">Where Innovation Meets Design</h2>
            <p className="smal-title">Access your exhibition management dashboard and oversee every aspect of Egypt's premier design event.</p>
          </div>
        </div>

        <div className="login-right" ref={rightRef}>
          <div className="login-form-container">

            <h1 className="login-title" ref={titleRef}>Welcome Back</h1>
            <p className="login-subtitle" ref={subtitleRef}>Sign in to access your dashboard</p>

            <div className="login-form" ref={formRef}>

              <div className="login-field">
                <label className="login-label">Email Address</label>
                <div className="login-input-wrap">
                  <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2"/>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                  </svg>
                  <input
                    type="email"
                    className="login-input"
                    placeholder="admin@thedesignshow.eg"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setError(''); }}
                    required
                  />
                </div>
              </div>

              <div className="login-field">
                <label className="login-label">Password</label>
                <div className="login-input-wrap">
                  <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="login-input"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => { setPassword(e.target.value); setError(''); }}
                    required
                  />
                  <button type="button" className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {error && <p className="login-error">{error}</p>}

              <p className="forgot-link">Forgot Password?</p>

            </div>

            <div className="login-btn-group" ref={btnGroupRef}>
              <Link to="/home" className="no-underline-link" onClick={handleLinkClick}>
                <Btn2 btnt="Login to Dashboard" />
              </Link>

              <div className="login-or"><span>OR</span></div>
              <Link to="/error" className="no-underline-link">
                <Btn4 btnt="Continue as Guest" />
              </Link>
            </div>

            <p className="login-footer" ref={footerRef}>
              Don't have an account? <span className="register-link">Sign Up</span>
            </p>
            <p className="login-copyright" ref={footerRef}>© 2025 The Design Show. All rights reserved.</p>

          </div>
        </div>

      </div>
    </>
  );
};

export default Login;